import { render, staticRenderFns } from "./LeftDisplay2.vue?vue&type=template&id=62f5b67c&scoped=true"
import script from "./LeftDisplay2.vue?vue&type=script&lang=js"
export * from "./LeftDisplay2.vue?vue&type=script&lang=js"
import style0 from "./LeftDisplay2.vue?vue&type=style&index=0&id=62f5b67c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f5b67c",
  null
  
)

export default component.exports